import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import './profitrover-skeleton.css';

const ProfitRoverSkeleton = () => (
  <div className="skeleton">
    <div className="charts">
      <div className="chart-block">
        <div className="chart-title">
          <Skeleton width={200} />
        </div>
        <Skeleton variant="circular" width={200} height={200} />
      </div>
      <div className="chart-block">
        <div className="chart-title">
          <Skeleton width={200} />
        </div>
        <Skeleton variant="rectangular" width={250} height={200} />
      </div>
      <div className="chart-block">
        <div className="chart-title">
          <Skeleton width={200} />
        </div>
        <Skeleton variant="rectangular" width={250} height={200} />
      </div>
      <div className="chart-block">
        <div className="chart-title">
          <Skeleton width={200} />
        </div>
        <Skeleton variant="rectangular" width={250} height={200} />
      </div>
    </div>

    <div className="table">
      <Skeleton variant="rectangular" width="100%" height={200} />
    </div>
  </div>
);

export default ProfitRoverSkeleton;
